<template>
  <div id="create-account" class="flex column wrap justify-center grow-1">
    <div class="return-link flex column align-end">
      <nav class="flex column align-end">
        <router-link to="/" class="color-text">
          &lt; Regresar
        </router-link>
      </nav>
    </div>
    <form class="form flex column grow-1 align-start align-self-center justify-center justify-flex-start-sm">
      <h1>REGISTRA TU CUENTA</h1>
      <div class="form-group flex justify-space-between dspl-block-sm">
        <label>Tipo de cuenta:</label>
        <div>
          <input
            @input="accountType = 0"
            type="radio"
            name="account-type"
            id="type-lexpress"
            value="0"
            :checked="accountType === 0"
          />
          <label for="type-lexpress">Línea Exprés</label>
        </div>
        <div>
          <input
            @input="accountType = 1"
            type="radio"
            name="account-type"
            id="type-ce"
            value="1"
            :checked="accountType === 1"
          />
          <label for="type-ce">Control Empresarial</label>
        </div>
      </div>
      <div class="form-group">
        <div class="sentri-input">
          <input
            @keypress.enter="submitLogin"
            type="text"
            id="sentri"
            name="sentri"
            :placeholder="sentriInputLabel"
            class="text-input"
            v-model="sentri"
            required
          />
          <button v-if="this.showSentri" class="btn" @click.prevent="showModalSentri = true">?</button>
        </div>
        <span v-if="this.errors.sentri.length" class="error">{{ this.errors.sentri[0] }}</span>
      </div>
      <div class="form-group">
        <input
          @keypress.enter="submitLogin"
          type="email"
          id="email"
          name="email"
          placeholder="Correo"
          class="text-input"
          v-model="email"
          autofocus
          required
        />
        <span v-if="this.errors.email.length" class="error">{{ this.errors.email[0] }}</span>
      </div>
      <div class="form-group">
        <input
          @keypress.enter="submitLogin"
          type="password"
          id="password"
          name="password"
          placeholder="Contraseña"
          class="text-input"
          v-model="password"
          autofocus
          required
        />
        <span v-if="this.errors.password.length" class="error">{{ this.errors.password[0] }}</span>
      </div>
      <div class="flex justify-space-evenly dspl-inline-grid-m dspl-inline-grid-sm justify-stretch-sm login-buttons">
        <button v-if="!loading" class="btn" @click.prevent="submitLogin">Enviar mis datos</button>
        <button v-if="loading" disabled="true" class="btn disabled flex justify-center" @click.prevent="">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-notch" class="loading-icon svg-inline--fa fa-circle-notch fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>
          Cargando
        </button>
      </div>
      <InformationModal
        @confirm="showModalSentri = false"
        :active="showModalSentri"
        title="¿Dónde encuentro mi Sentri?"
      >
        <template #content>
          <img src="@/assets/images/sentri.png">
        </template>
      </InformationModal>
      <ErrorModal
        @confirm="showErrorModal = false"
        :active="showErrorModal"
        message="No hemos podido confirmar tus datos, por favor contacta con el Fideicomiso de Puentes Fronterizos de Chihuahua"
      />
      <InformationModal
      @confirm="showInfoModal = false"
      :active="showInfoModal"
      title="Atención"
      >
      <template #content>
        {{ requestMessage }}
      </template>
    </InformationModal>
      <SuccessModal
        @confirm="showSuccessModal = false"
        :active="showSuccessModal"
        message="Listo, hemos comprobado tus datos, ahora podrás iniciar sesión."
      />
    </form>
  </div>
</template>

<script>
import { requestAccount } from '@/api/users'
import ErrorModal from '@/components/ErrorModal'
import SuccessModal from '@/components/SuccessModal'
import InformationModal from '@/components/InformationModal'

export default {
  name: 'CreateAccount',
  data () {
    return {
      showErrorModal: false,
      showSuccessModal: false,
      showInfoModal: false,
      showModalSentri: false,
      requestMessage: '',
      accountType: 0,
      email: '',
      sentri: '',
      password: '',
      loading: false,
      errors: {
        email: [],
        sentri: [],
        password: []
      }
    }
  },
  computed: {
    sentriInputLabel: function () {
      if (this.accountType === 0) {
        return 'Sentri'
      } else {
        return 'RFC'
      }
    },
    showSentri: function () {
      return this.accountType === 0
    }
  },
  components: {
    ErrorModal,
    SuccessModal,
    InformationModal
  },
  methods: {
    cleanErrors () {
      this.errors = {
        email: [],
        sentri: [],
        password: []
      }
    },
    submitLogin: function () {
      const sentriRegexp = /^[A-Z0-9]+$/
      const emailRegexp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
      const rfcRegexp = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/
      const passRegexp = /^.{6,}$/

      this.cleanErrors()

      if (this.accountType === 0 && !sentriRegexp.test(this.sentri)) {
        this.errors = { ...this.errors, sentri: ['El sentri solamente puede contener mayúsculas y números'] }
      }
      if (this.accountType === 1 && !rfcRegexp.test(this.sentri)) {
        this.errors = { ...this.errors, sentri: ['El RFC debe tener un formato válido'] }
      }
      if (!emailRegexp.test(this.email)) {
        this.errors = { ...this.errors, email: ['El email debe tener un formato válido'] }
      }
      if (!passRegexp.test(this.password)) {
        this.errors = { ...this.errors, password: ['Tú contraseña debe al menos tener seis caracteres'] }
      }

      if (!this.errors.email.length && !this.errors.sentri.length && !this.errors.password.length) {
        this.sendData()
      }
    },
    sendData () {
      this.loading = true
      const data = { email: this.email, sentri: this.sentri, password: this.password }

      setTimeout(() => {
        requestAccount(data).then(() => {
          this.loading = false
          this.showSuccessModal = true
          this.email = ''
          this.sentri = ''
          this.password = ''
        }).catch(({ response }) => {
          if (response.status === 422) {
            this.showInfoModal = true
            this.requestMessage = response.data.message
          } else {
            this.showErrorModal = true
          }
          this.loading = false
        })
      }, 5000)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#create-account {
  height: 100vh;
}

.form {
  width: 50%;
}

.return-link {
  width: 89%;
  margin-top: 8%;
}

.form-group {
  width: 100%;
  margin: 1rem 0;
  text-align: left;
}

.text-input {
  font-size: 1rem;
  padding: 0.8rem;
  border-radius: 20px;
  border-width: 0;
  width: 100%;

  &:focus {
    outline-width: 0;
  }
}

.error {
  font-size: 0.75rem;
  color: $red;
  margin: 0 0.5rem;
}

.btn {
  font-size: 0.8rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6rem 1.5rem;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.disabled {
    cursor: default;
  }
}

.loading-icon {
  animation-name: spin;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  width: 1rem;
  margin-right: 0.5rem;
}

.color-text {
  color: $blue;
  text-decoration: none;
}

.login-buttons {
  width: 100%;
}

.sentri-input {
  width: 100%;
  position: relative;

  .btn {
    position: absolute;
    top: 0;
    right: -1rem;
    margin: 6px 0;
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@media screen and (max-width: 960px) {
  .form {
    width: 80%;
  }
}

@media screen and (max-width: 480px) {
  #reset-password-request {
    height: 75vh;
    min-height: 526px;
  }

  .form {
    width: 70%;
    margin: 5% 0 5% 0;
  }

  .nav {
    bottom: 5%;
  }
}
</style>
